import { Total } from "@repo/apis/bag";
import { BagSdkMethod } from "../utils/method-initialiser";

export type TotalPrice = {
  text: string;
  value: number;
  xrp: number;
} | null;

type PublicGetTotalPriceMethod = () => TotalPrice;
type GetTotalPriceMethod = BagSdkMethod<PublicGetTotalPriceMethod>;

export const getTotalPriceInitialiser: GetTotalPriceMethod =
  ({ state }) =>
  () => {
    const bag = state.getBag();

    if (!bag || !bag.total) {
      return null;
    }

    return {
      text: (bag.total as Total).total.text,
      value: (bag.total as Total).total.value,
      xrp: (bag.total as Total).total.xrp,
    };
  };
